import type { IConcurrencyGroup } from "@/@types/gamification";

import {
  CONCURRENCY_GROUP_LOCALE,
  ConcurrencyGroupListState,
} from "../constants/concurrency-group";

export function normalizeGroupName(value: unknown): string {
  return String(value ?? "").trim();
}

function groupKey(value: string): string {
  return normalizeGroupName(value).toLocaleLowerCase(CONCURRENCY_GROUP_LOCALE);
}

export function findConcurrencyGroup(
  groups: IConcurrencyGroup[] | undefined,
  name: string,
): IConcurrencyGroup | undefined {
  const key: string = groupKey(name);
  if (!key) return undefined;
  return groups?.find((group) => groupKey(group.name) === key);
}

export function isSameGroupName(left: string, right: string): boolean {
  return groupKey(left) === groupKey(right);
}

interface ListStateInputs {
  isLoading: boolean;
  isError: boolean;
  hasData: boolean;
}

export function resolveConcurrencyGroupListState({
  isLoading,
  isError,
  hasData,
}: ListStateInputs): ConcurrencyGroupListState {
  if (isLoading && !hasData) return ConcurrencyGroupListState.LOADING;
  if (isError) return ConcurrencyGroupListState.ERROR;
  return ConcurrencyGroupListState.READY;
}
